import { StrapiApi } from "./Api";

export const strapiBaseUrl = process.env.REACT_APP_STRAPI_API as string;

const strapiToken = process.env.REACT_APP_STRAPI_TOKEN as string | undefined;

export const strapiApi = new StrapiApi(strapiBaseUrl, strapiToken);
